


















































































































































































import ApiHelper from 'api-helper';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import Toast from '@common/helpers/toast';
import PageLoader from '@components/common/PageLoader.vue';
import KarteLoadingOverlay from '@components/common/KarteLoadingOverlay.vue';
import { PLAN_PAYMENT_TYPE } from '@/common/constants/plan';
import moment from 'moment';
import { extend } from 'vee-validate';
import { USER_STATE, USER_STATUS } from '@/common/constants/auth';
import { State } from 'vuex-class';
import { UserTreatment } from '@/models/user-treatment';
import { Patient } from '@/models/patient';
import { isChangedPlan } from '@common/helpers/plan-highlight';
import {
  getBMIDisplay,
  getPatientBirthdayDisplay,
  getPatientFullName,
  getPatientGenderDisplay,
  getPatientKanaName,
} from '@common/helpers/patient-info';
import KarteDraftMixin from '@common/mixins/KarteDraftMixin';
import { applyKarteDraft } from '@common/helpers/karte-draft';
import { formatInTokyo } from '@common/helpers/datetime-tokyo';

extend('notSpecialChar', (text) => {
  const textCompare = text;
  if (text) {
    return textCompare.replace(
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u203A\u203C-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
      '',
    ).length == text.length
      ? true
      : '絵文字または特殊記号を入力しないでください。';
  }
  return true;
});

@Component({
  components: {
    PageLoader,
    KarteLoadingOverlay,
  },
  filters: {
    // No.173: in Japan time whatever the browser's timezone, and through the
    // same conversion as the 一時保存 label below it — the two used to differ
    // by the browser's offset from JST (see formatInTokyo).
    formatTime(value) {
      return formatInTokyo(value, 'YYYY年 MM月DD日 HH:mm');
    },
    formatDate(value) {
      return (value ? moment(value) : moment()).format('YYYY年MM月DD日');
    },
  },
})
export default class PrescriptionPopup extends Mixins(KarteDraftMixin) {

  private get prescriptionFormRef() {
    return this.$refs.prescriptionForm as any;
  }

  /**
   * No.173 — the patient this popup is about, for everything this ticket adds.
   *
   * On the chat screen that is the `currentChannelUser` prop — the same object
   * the header's 「カルテ : 姓 名」 is rendered from. NOT `currentPatient`: the
   * patient_detail store is filled only by the v2 patient screen, so here it
   * is either empty (the details and 一時保存 silently do nothing) or still
   * holding the last patient opened elsewhere — which would print one
   * patient's age and gender under another patient's name.
   *
   * The channel user is a User, not a Patient, so it has no `fullName`; it is
   * rebuilt from the same family/given names the header uses.
   */
  private get channelPatient(): any {
    const user: any = this.currentChannelUser || {};
    const fullName = `${user.family_name || ''} ${user.given_name || ''}`.trim();
    return { ...user, fullName: user.fullName || fullName };
  }

  /**
   * The treatment this popup is about — resolved exactly as menuName and
   * changedPlanId already are in this file, because the treatment_detail store
   * is not kept in step with the chat screen either.
   */
  private get karteTreatment(): any {
    return this.isActiveTreatmentCurrent
      ? this.activeTreatment
      : this.currentChannelUser?.user_treatment;
  }

  // No.173 — patient facts the doctor was leaving the popup to check.
  get patientFullName(): string {
    return getPatientFullName(this.channelPatient);
  }

  get patientKanaName(): string {
    return getPatientKanaName(this.channelPatient);
  }

  get patientBirthdayDisplay(): string {
    return getPatientBirthdayDisplay(this.channelPatient);
  }

  get patientGenderDisplay(): string {
    return getPatientGenderDisplay(this.channelPatient);
  }

  get bmiDisplay(): string {
    return getBMIDisplay(this.reservationAnswers, this.menuName);
  }

  /**
   * A draft only makes sense while composing a NEW karte; reopening a saved
   * one shows stored content, and a draft there would never be restored.
   */
  get canSaveKarteDraft(): boolean {
    return !this.prescriptionForm?.id
      && !!this.currentChannelUser?.id
      && !!this.karteTreatment?.id;
  }

  private get isActiveTreatmentCurrent() {
    return !!(this.activeTreatment?.id
      && this.activeTreatment.id === this.currentChannelUser?.user_treatment?.id);
  }

  private get menuName() {
    const menu = this.isActiveTreatmentCurrent
      ? this.activeTreatment.menu
      : this.currentChannelUser?.user_treatment?.menu;
    if (menu) {
      return menu.name;
    }

    return '';
  }

  private get changedPlanId() {
    const plan = this.isActiveTreatmentCurrent
      ? this.activeTreatment.plan
      : this.currentChannelUser?.user_treatment?.plan;
    return plan ? plan.id : null;
  }
  @State((state) => state.patient_detail.data) currentPatient!: Patient;
  @Prop() changeState: any;
  @Prop() currentChannelUser!: any;
  @Prop() changeCurrentChannelUser!: any;
  @State((state) => state.treatment_detail.data) activeTreatment: UserTreatment;

  protected PRESCRIPTION_TYPE = {
    PRESCRIPTION: 'prescription',
    NG: 'ng',
  };
  private isSubmitting: boolean = false;
  private isLoading: boolean = false;
  private listPlan: any[] = [];

  private PLAN_PAYMENT_TYPE: any = PLAN_PAYMENT_TYPE;
  private prescriptionForm: any = {
    content: null,
    type: null,
    plans: [],
  };
  private isPrescription: boolean = false;
  private isNG: boolean = false;
  private prescriptionType: string = '';

  mounted() {
    if (this.currentChannelUser.state === USER_STATUS.CHOICE_INTERVIEW_METHOD) {
      this.getListPlans();
    }
  }

  show(currentPrescription) {
    this.prescriptionForm = currentPrescription;
    this.prescriptionType = currentPrescription.type;
    // No.173: a new opening — responses still in flight for the previous
    // patient are dropped from here on (isStaleKarteRequest).
    this.beginKarteOpen();
    this.$modal.show('prescriptionForm');
    // No.173: after the modal, so the form is never held back by the network.
    this.restoreKarteDraft();
    this.loadReservationAnswers();
  }

  getListPlans() {
    this.isLoading = true;
    const self = this;
    const payload = { user_treatment_id: this.currentChannelUser?.user_treatment?.id };
    ApiHelper.getApi('PatientV2Api')
      .getPlansByPatientId(this.currentChannelUser.id, payload)
      .then(function(res, error) {
        self.listPlan = res.data;
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(function() {
        self.isLoading = false;
      });
  }

  makeListPlans() {
    return this.prescriptionForm.id == null
      ? this.listPlan
      : this.prescriptionForm.listPlans;
  }

  prescriptionHandle() {
    this.isPrescription = true;
    this.prescriptionType = this.PRESCRIPTION_TYPE.PRESCRIPTION;
    this.prescriptionForm.type = this.PRESCRIPTION_TYPE.PRESCRIPTION;
  }

  ngHandle() {
    this.isNG = true;
    this.prescriptionType = this.PRESCRIPTION_TYPE.NG;
    this.prescriptionForm.type = this.PRESCRIPTION_TYPE.NG;
  }

  async savePrescriptionForm() {
    const isValid = await this.prescriptionFormRef.validate();
    if (!isValid) {
      return;
    }
    const data = {
      user_id: this.currentChannelUser.id,
      content: this.prescriptionForm.content,
      plans:
        this.prescriptionForm.type === this.PRESCRIPTION_TYPE.PRESCRIPTION
          ? this.prescriptionForm.plans
          : null,
      type: this.prescriptionForm.type,
      user_treatment_id: this.activeTreatment.id,
    };
    this.isSubmitting = true;
    const self = this;

    if (this.prescriptionForm.id) {
      await ApiHelper.getApi('DoctorMouthApi')
        .updateFeedback(this.prescriptionForm.id, data)
        .catch((error: any) => {
          error.response && Toast.error(error.response.data.message);
        })
        .finally(function() {
          self.isSubmitting = false;
          self.$modal.hide('prescriptionForm');
        });
    } else {
      // new feedback.
      await ApiHelper.getApi('PatientV2Api')
        .createFeedback(this.currentPatient.id, data)
        .then(function(res, error) {
          self.$emit('submit', res.data);
        })
        .catch((error: any) => {
          error.response && Toast.error(error.response.data.message);
        })
        .finally(function() {
          self.isSubmitting = false;
          self.$modal.hide('prescriptionForm');
        });
    }

    // No.173: the API dropped the draft row in the same transaction as the
    // karte; only the popup's label is left to clear.
    self.resetKarteDraftState();

    self.$emit('savedFeedback');
  }

  /**
   * The built-in `max` rule has no Japanese message here (the app registers the
   * ja dictionary but never activates it), so it renders as the raw
   * "{field} is not valid" placeholder. Other screens work around this the same
   * way, with a per-field message. No.173 made this visible on 一時保存 too.
   */
  private get karteContentErrorMessages() {
    return {
      max: 'カルテは3000文字以内で入力してください',
    };
  }

  /** Read by KarteDraftMixin's beforeunload guard. */
  protected karteDraftLiveForm(): any {
    return this.canSaveKarteDraft ? this.prescriptionForm : null;
  }

  /**
   * Read by KarteDraftMixin's stale-response guard: the patient and treatment
   * this popup is showing now — the chat screen does not fill the stores, so the prop and the treatment resolved from it are the truth here (see channelPatient).
   */
  protected karteDraftContext(): { patientId: any; treatmentId: any } {
    return { patientId: this.currentChannelUser?.id, treatmentId: this.karteTreatment?.id };
  }

  private async restoreKarteDraft(): Promise<void> {
    this.resetKarteDraftState();
    if (!this.canSaveKarteDraft) {
      return;
    }
    const token = this.karteRequestToken(this.currentChannelUser?.id, this.karteTreatment?.id);
    const draft = await this.loadKarteDraft(this.currentChannelUser?.id, this.karteTreatment?.id);
    // Re-opened for another patient while this was loading: the draft belongs
    // to them, and applying it would put their text in this patient's karte.
    if (this.isKarteRequestStale(token)) {
      return;
    }
    if (!draft || !this.canSaveKarteDraft) {
      // Nothing stored: the form as prefilled (DEFAULT_KARTE_TEMPLATE included)
      // is the baseline, so the reload warning stays quiet until the doctor
      // actually types.
      this.markKarteDraftBaseline(this.prescriptionForm);
      return;
    }
    this.prescriptionForm = applyKarteDraft(this.prescriptionForm, draft);
    // This popup only offers 処方する / 処方NG, and both flags are plain
    // booleans the template reads — no handler to re-enter.
    this.prescriptionType = this.prescriptionForm.type || '';
    this.isPrescription = this.prescriptionType === this.PRESCRIPTION_TYPE.PRESCRIPTION;
    this.isNG = this.prescriptionType === this.PRESCRIPTION_TYPE.NG;
    this.markKarteDraftBaseline(this.prescriptionForm);
  }

  /**
   * 一時保存 — No.173 Q4 (案B, client-confirmed): the popup stays OPEN. It no
   * longer has to close for the doctor to look something up, because the
   * patient details they were leaving for are now shown in it (Q7).
   *
   * No.173 Q6 (案B): the draft is validated against the SAME content rules
   * this screen applies to the real karte, read off the content field's own
   * ValidationProvider rather than restated here — restating them is how the
   * two drift apart, and text that fails here must be text that would fail at
   * 保存 too. Only the content field is validated: the 処方 type and the plan
   * checkboxes are `required` for the real karte and deliberately not for a
   * draft, which is an unfinished form by definition.
   */
  private async saveKarteDraft(): Promise<void> {
    const contentProvider = this.$refs.karteContentProvider as any;
    if (contentProvider) {
      const result = await contentProvider.validate();
      if (result && result.valid === false) {
        return;
      }
    }
    await this.persistKarteDraft(
      this.currentChannelUser?.id,
      this.karteTreatment?.id,
      this.prescriptionForm,
    );
  }

  private isChangedPlan(planId: number | string) {
    return isChangedPlan(planId, this.changedPlanId);
  }
}
